import { appEntry } from '@/mocks/homeData';

export default function SectionApp() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const el = document.querySelector('#app');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="w-full lg:w-1/2 flex flex-col gap-6">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">
              {appEntry.title}
            </h2>
            <p className="text-lg text-primary-600 font-heading">{appEntry.subtitle}</p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              {appEntry.desc}
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {appEntry.features.map((feat) => (
                <div key={feat.text} className="flex items-center gap-3 p-3 rounded-xl bg-background-50 border border-background-200/60">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                    <i className={`${feat.icon} text-base`}></i>
                  </div>
                  <span className="text-sm text-foreground-800">{feat.text}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
              <a
                href="#app"
                onClick={handleClick}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-apple-line"></i>
                iOS 下载
              </a>
              <a
                href="#app"
                onClick={handleClick}
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-foreground-800 rounded-full text-sm font-medium hover:bg-background-200 transition-colors duration-200 whitespace-nowrap cursor-pointer border border-background-300/60"
              >
                <i className="ri-android-line"></i>
                Android 下载
              </a>
            </div>
          </div>

          <div className="w-full lg:w-1/2 flex justify-center">
            <div className="w-full max-w-[320px]">
              <img
                src={appEntry.image}
                alt="樱花漫画 APP 界面展示"
                className="w-full h-auto rounded-2xl"
                onError={(e) => {
                  (e.target as HTMLElement).parentElement!.style.display = 'none';
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}